import { AttackPattern, PatternState } from '../AttackPattern.js';

// Records where the player stood during the count-in, then plays those
// positions back as synchronized voices.
export class ChoirEchoStep extends AttackPattern {
  constructor({ config }) {
    super({ name: 'Echo Step', telegraphDuration: 1.15, activeDuration: 0.45, minPhase: 0 });
    this.config = config;
  }

  onBegin() { this._samples = []; this._sampleTimer = 0; }

  onTelegraphTick(dt, _boss, player) {
    this._sampleTimer -= dt;
    if (this._sampleTimer <= 0) {
      this._samples.push({ x: player.x, y: player.y });
      this._sampleTimer = 0.22;
    }
  }

  onActiveStart(boss, _player, pool) {
    const positions = this._samples.slice(-3);
    if (boss.phase >= 1 && positions[0]) positions.push({ x: boss.x * 2 - positions[0].x, y: boss.y * 2 - positions[0].y });
    const count = boss.phase >= 2 ? 8 : 6;
    positions.forEach((pos, source) => {
      for (let i = 0; i < count; i++) {
        const a = (i / count) * Math.PI * 2 + (source % 2) * Math.PI / count;
        pool.fire({ x: pos.x, y: pos.y, vx: Math.cos(a) * this.config.speed, vy: Math.sin(a) * this.config.speed, radius: 2.2, damage: this.config.damage, color: source % 2 ? '#8ad1ff' : '#c084fc', lifetime: 3.2 });
      }
    });
  }

  onEnd(boss) { boss.openVulnerability(0.65, 1.55); }

  getVisual() {
    if (this.state !== PatternState.TELEGRAPH) return null;
    return { kind: 'echoStep', positions: this._samples };
  }
}
